/* @flow */

import React from 'react';
import { Dropdown } from 'semantic-ui-react';

type Props = {
  value: CatalogPlatform,
  platforms: Array<CatalogPlatform>,
  onChange: (platform: CatalogPlatform) => void,
};

const platformValues = platforms =>
  platforms.map(p => ({
    value: p.code,
    text: p.label,
  }));

const PlatformSelector = ({ value, platforms, onChange }: Props) => {
  const change = (_, { value }) => {
    const target = platforms.find(p => p.code === value);
    if (target) {
      onChange(target);
    }
  };

  return (
    <Dropdown
      value={value.code}
      selection
      options={platformValues(platforms)}
      onChange={change}
    />
  );
};

export default PlatformSelector;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/PlatformSelector.js